import SEOHead from '@/components/base/SEOHead';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HomeSections';
import { CategoryGridSection, HotPicksSection, LatestUpdatesSection, FeaturesBanner } from './components/HomeSections';

export default function Home() {
  return (
    <>
      <SEOHead />
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebSite" />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '90影视 - 免费在线观看不缓冲全集高清影视平台',
          description: '90影视免费在线观看平台，电影电视剧综艺动漫全集不缓冲无广告，高清画质流畅播放，最新热剧每日更新，省钱追剧首选90影视。',
          url: 'https://www.90yingshi.com',
          breadcrumb: {
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.90yingshi.com' },
            ],
          },
        }}
      />

      <main>
        <HeroSection />
        <FeaturesBanner />
        <CategoryGridSection />
        <HotPicksSection />
        <LatestUpdatesSection />
      </main>
    </>
  );
}